import React, { memo, useRef } from 'react';

import cn from 'classnames';

import { getValidatedFormats } from '@entities/attachment/lib';
import { useToggleState } from 'shared/hooks';
import { CircularLoader } from 'shared/ui';

import cls from './FileItem.module.css';
import { FileItemActions } from './FileItemActions';
import { FileItemImg } from './FileItemImg';
import { FileItemSvg } from './FileItemSvg';
import { removeFileExtension } from '../../../lib/removeFileExtension';

interface IFileItem {
    onOpenMenu: (fileId: string, position: { x: number; y: number }) => void;
    onCloseMenu: () => void;
    containerRef: React.RefObject<HTMLDivElement>;
    activeMenuFileId: string;
    onFileItemClick: (e: React.SyntheticEvent, fileId: string) => void;

    fileName: string;
    fileExtension: string;
    isFromClient: boolean;
    imgUrl: string;
    isImage: boolean;
    isLoading: boolean;
    fileId: string | number;
    file?: File;
}

export const FileItem = memo(
    ({
        fileName,
        isFromClient,
        fileExtension,
        imgUrl,
        isImage,
        file,
        isLoading,
        onOpenMenu,
        onCloseMenu,
        onFileItemClick,
        containerRef,
        activeMenuFileId,
        fileId,
    }: IFileItem) => {
        const [isHovered, toggleHover, setToggle] = useToggleState(false);

        const actionButtonRef = useRef<HTMLDivElement>(null);
        const nameWithoutExtension = removeFileExtension(fileName, getValidatedFormats());

        const handleActionsClick = (e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            if (activeMenuFileId === fileId) {
                onCloseMenu();
                return;
            }

            if (activeMenuFileId !== null) {
                onCloseMenu();
            }

            if (actionButtonRef.current && containerRef.current) {
                const buttonRect = actionButtonRef.current.getBoundingClientRect();
                const containerRect = containerRef.current.getBoundingClientRect();

                let x = buttonRect.left - containerRect.left;
                let y = buttonRect.top - containerRect.top;

                y += 20;
                x -= 80;

                // onOpenMenu(String(file.id), { x, y });
                onOpenMenu(String(fileId), { x, y });
            }
        };

        return (
            <li
                className={cls.fileItemWrapper}
                onClick={(e) => onFileItemClick(e, String(fileId))}
                onMouseEnter={() => {
                    setToggle(false);
                    toggleHover();
                }}
                onMouseLeave={toggleHover}
                draggable={false}
                onDragStart={(e) => e.preventDefault()}
            >
                <span className={cn(cls.fileItem, { [cls.isHovered]: isHovered })}>
                    {isImage ? (
                        <>
                            {isLoading && <CircularLoader size={26} />}
                            {/* {!isLoading && ( */}
                            {/*    <img src={imgUrl} alt={fileName} className={cls.filePreview} /> */}
                            {/* )} */}
                            {!isLoading && (
                                <FileItemImg imgUrl={imgUrl} fileName={nameWithoutExtension} />
                            )}
                            <div className={cls.fileInfoWrapper}>
                                <p className={cls.fileName}>{nameWithoutExtension}</p>
                                <span className={cls.fileExtension}>.{fileExtension}</span>
                            </div>
                        </>
                    ) : (
                        <>
                            {isLoading && <CircularLoader size={26} />}
                            {!isLoading && <FileItemSvg extension={fileExtension} />}
                            {/* {!isLoading && <Icon iconName={'fileItemPlaceholder'} />} */}
                            <div className={cls.fileInfoWrapper}>
                                <p className={cls.fileName}>{nameWithoutExtension}</p>
                                <span className={cls.fileExtension}>.{fileExtension}</span>
                            </div>
                        </>
                    )}
                </span>
                {isHovered && (
                    <FileItemActions
                        onClickHandler={handleActionsClick}
                        innerRef={actionButtonRef}
                    />
                )}
            </li>
        );
    }
);
